import { Injectable, signal } from '@angular/core';

export type AppTheme = 'standard' | 'dark' | 'light';

const STORAGE_KEY = 'app-theme';
const THEME_CLASSES: AppTheme[] = ['standard', 'dark', 'light'];

@Injectable({ providedIn: 'root' })
export class ThemeService {
  readonly currentTheme = signal<AppTheme>(this.loadTheme());

  constructor() {
    this.applyTheme(this.currentTheme());
  }

  setTheme(theme: AppTheme): void {
    this.currentTheme.set(theme);
    localStorage.setItem(STORAGE_KEY, theme);
    this.applyTheme(theme);
  }

  private loadTheme(): AppTheme {
    const stored = localStorage.getItem(STORAGE_KEY) as AppTheme | null;
    return stored && THEME_CLASSES.includes(stored) ? stored : 'standard';
  }

  private applyTheme(theme: AppTheme): void {
    const body = document.body;
    THEME_CLASSES.forEach((t) => body.classList.remove(`theme-${t}`));
    if (theme !== 'standard') {
      body.classList.add(`theme-${theme}`);
    }
  }
}
